import { AppConfig } from './../app.config';
import { Observable } from 'rxjs';
import { DashboardEventService } from './../dashboard/dashboard-event.service';
import { SnapshotService } from './../snapshot/snapshot.service';
import { environment } from './../../environments/environment';
import { AppEnvironment } from './../app-env';
import { CognitoUtil } from './../authentication/cognito.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseRestService } from '../service/base-rest.service';
import { ServiceRegistry } from '../service/service-registry.service';
import { AccountBalanceData, GetDailyBalanceOutput, WebApiEndpoints, CurrencyUtil } from '@liquitics/transaction';
import { productTypeDisplayName } from '../common/product-types';
import { AwsUtil } from '../authentication/aws.service';


@Injectable()
export class AccountBalanceService extends BaseRestService<GetDailyBalanceOutput> {
    constructor(protected http: HttpClient,
        protected awsUtil: AwsUtil,
        protected serviceRegistry: ServiceRegistry,
        protected dashboardEventService: DashboardEventService,
        private snapshotService: SnapshotService,
        private appConfig: AppConfig) {
        super(http, awsUtil, serviceRegistry, dashboardEventService);
    }

    getAPIName(params?: any): string {
        return WebApiEndpoints.QueryDailyBalance;
        // const date = params.date;
        // return this.tenantInfo.apiUrl + 'balances/?Date=' + date +
        //     '&Currencies=' + this.appConfig.activeUserProfile.getCurrencies().join(',');

    }

    useDemoDataFile(): boolean {
        return false;
    }
}
